module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/en/1/4-7e62ffc7cdbcae5e4718ab6f314bce08.jpg";